var $$ = $$ || {};

$$.Noty = {
	confirmCity:    function (city, cityId) {
		"use strict";

		var n = noty({
			layout:    'top',
			text:      `Ваш город — ${city}?`,
			theme:     'elementTheme',
			type:      'confirm',
			template:  `
			<div class="noty_message">
			<span class="noty_text"></span>
			<div class="noty_close"></div>
			</div>
			`,
			animation: {
				open:   'animated fadeInDown', // Animate.css class names
				close:  'animated fadeOutUp', // Animate.css class names
				easing: 'swing', // unavailable - no need
				speed:  500 // unavailable - no need
			},
			closeWith: [ 'button' ],
			callback:  {
				onShow:       function () {
					this.$bar.find('.noty_bar').append('<div class="noty_label">От выбора города зависит способ и стоимость доставки.</div>');
					$('<span class="noty_close g-icon g-icon-close"></span>').appendTo(this.$bar.find('.noty_bar')).on('click', (event) => {
						this.close();
					});
				},
				afterShow:    function () {
				},
				onClose:      function () {
				},
				afterClose:   function () {
				},
				onCloseClick: function () {
				}
			},
			buttons:   [ {
				addClass: 'button', text: 'Да', onClick: function ($noty) {
					$.ajax({
						url:     $$.Config.confirmCity,
						method:  'POST',
						data:    {
							id: cityId
						},
						success: (response) => {
							response = $.parseJSON(response);

							if (response.success) {
								$noty.close();
							}
						}
					});
				}
			}, {
				addClass: 'button', text: 'Выбрать другой', onClick: function ($noty) {
					$('.js-city-name-in-header').trigger('click');
					$noty.close();
				}
			} ]
		});
	},
	successMessage: function (message) {
		"use strict";

		var n = noty({
			layout:    'top',
			text:      message,
			theme:     'elementTheme',
			type:      'success',
			template:  `
			<div class="noty_message">
			<span class="noty_text"></span>
			<div class="noty_close g-icon g-icon-close"></div>
			</div>
			`,
			animation: {
				open:   'animated fadeInDown', // Animate.css class names
				close:  'animated fadeOutUp', // Animate.css class names
				easing: 'swing', // unavailable - no need
				speed:  500 // unavailable - no need
			},
			closeWith: [ 'button' ],
			timeout:   1500,
			callback:  {
				onShow:       function () {
				},
				afterShow:    function () {
					if (this.options.timeout) {
						setTimeout(() => {
							this.close();
						}, this.options.timeout);
					}
				},
				onClose:      function () {
				},
				afterClose:   function () {
				},
				onCloseClick: function () {
				}
			},
			buttons:   false
		});
	},
	errorMessage:   function (message, close = 2000) {
		"use strict";

		var n = noty({
			layout:    'top',
			text:      message,
			theme:     'elementTheme',
			type:      'error',
			template:  `
			<div class="noty_message">
			<span class="noty_text"></span>
			<div class="noty_close g-icon g-icon-close"></div>
			</div>
			`,
			animation: {
				open:   'animated fadeInDown', // Animate.css class names
				close:  'animated fadeOutUp', // Animate.css class names
				easing: 'swing', // unavailable - no need
				speed:  500 // unavailable - no need
			},
			closeWith: [ 'button' ],
			timeout:   close,
			callback:  {
				onShow:       function () {
				},
				afterShow:    function () {
					if (this.options.timeout) {
						setTimeout(() => {
							this.close();
						}, this.options.timeout);
					}
				},
				onClose:      function () {
				},
				afterClose:   function () {
				},
				onCloseClick: function () {
				}
			},
			buttons:   false
		});
	}
};


$.noty.themes.elementTheme = {
	name:     'elementTheme',
	helpers:  {
		borderFix: function () {
			if (this.options.dismissQueue) {
				var selector = this.options.layout.container.selector + ' ' + this.options.layout.parent.selector;
				switch (this.options.layout.name) {
					case 'top':

						//$(selector).css({borderRadius: '0px 0px 0px 0px'});
						//$(selector).last().css({borderRadius: '0px 0px 5px 5px'});
						break;
					case 'topCenter':
					case 'topLeft':
					case 'topRight':
					case 'bottomCenter':
					case 'bottomLeft':
					case 'bottomRight':
					case 'center':
					case 'centerLeft':
					case 'centerRight':
					case 'inline':
						$(selector).css({ borderRadius: '0px 0px 0px 0px' });
						$(selector).first().css({ 'border-top-left-radius': '5px', 'border-top-right-radius': '5px' });
						$(selector).last().css({
							'border-bottom-left-radius':  '5px',
							'border-bottom-right-radius': '5px'
						});
						break;
					case 'bottom':
						$(selector).css({ borderRadius: '0px 0px 0px 0px' });
						$(selector).first().css({ borderRadius: '5px 5px 0px 0px' });
						break;
					default:
						break;
				}
			}
		}
	},
	modal:    {
		css: {
			position:        'fixed',
			width:           '100%',
			height:          '100%',
			backgroundColor: '#000',
			zIndex:          10000,
			opacity:         0.6,
			display:         'none',
			left:            0,
			top:             0
		}
	},
	style:    function () {
		this.$bar.on({
			mouseenter: function () {
				$(this).find('.noty_close').stop().fadeTo('normal', 1);
			},
			mouseleave: function () {
				$(this).find('.noty_close').stop().fadeTo('normal', 0);
			}
		});

		switch (this.options.layout.name) {
			case 'top':
				break;
			case 'topCenter':
			case 'center':
			case 'bottomCenter':
			case 'inline':
				this.$bar.css({
					borderRadius: '5px',
					border:       '1px solid #eee',
					boxShadow:    "0 2px 4px rgba(0, 0, 0, 0.1)"
				});
				this.$message.css({ fontSize: '13px', textAlign: 'center' });
				break;
			case 'topLeft':
			case 'topRight':
			case 'bottomLeft':
			case 'bottomRight':
			case 'centerLeft':
			case 'centerRight':
				this.$bar.css({
					borderRadius: '5px',
					border:       '1px solid #eee',
					boxShadow:    "0 2px 4px rgba(0, 0, 0, 0.1)"
				});
				this.$message.css({ fontSize: '13px', textAlign: 'left' });
				break;
			case 'bottom':
				this.$bar.css({
					borderRadius: '5px 5px 0px 0px',
					borderTop:    '2px solid #eee',
					borderLeft:   '2px solid #eee',
					borderRight:  '2px solid #eee',
					boxShadow:    "0 -2px 4px rgba(0, 0, 0, 0.1)"
				});
				break;
			default:
				this.$bar.css({
					border:    '2px solid #eee',
					boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
				});
				break;
		}

		switch (this.options.type) {
			case 'alert':
			case 'notification':
				this.$bar.css({ backgroundColor: '#FFF', borderColor: '#CCC', color: '#444' });
				break;
			case 'warning':
				this.$bar.css({ backgroundColor: '#FFEAA8', borderColor: '#FFC237', color: '#826200' });
				this.$buttons.css({ borderTop: '1px solid #FFC237' });
				break;
			case 'error':
				/*this.$bar.css({backgroundColor: 'red', borderColor: 'darkred', color: '#FFF'});
				 this.$message.css({fontWeight: 'bold'});
				 this.$buttons.css({borderTop: '1px solid darkred'});*/
				break;
			case 'information':
				this.$bar.css({ backgroundColor: '#57B7E2', borderColor: '#0B90C4', color: '#FFF' });
				this.$buttons.css({ borderTop: '1px solid #0B90C4' });
				break;
			case 'success':
				this.$bar.css({ backgroundColor: 'lightgreen', borderColor: '#50C24E', color: 'darkgreen' });
				this.$buttons.css({ borderTop: '1px solid #50C24E' });
				break;
			case 'confirm':
				/*this.$bar.css({
				 backgroundColor: 'lightgreen', borderColor: '#50C24E', color: 'darkgreen'
				 });
				 this.$buttons.css({borderTop: '1px solid #50C24E'});*/
				break;
			default:
				this.$bar.css({ backgroundColor: '#FFF', borderColor: '#CCC', color: '#444' });
				break;
		}
	},
	callback: {
		onShow:  function () {
			$.noty.themes.elementTheme.helpers.borderFix.apply(this);
		},
		onClose: function () {
			$.noty.themes.elementTheme.helpers.borderFix.apply(this);
		}
	}
};
